export default {"src":"/_next/static/media/north-macedonia.677c1ccd.svg","height":16,"width":22,"blurWidth":0,"blurHeight":0};